import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/5d9802ba43525070add1fcfd005aa0ad/5051eaabd0bbd242b70ed8ddea3511f5.png";

const navItems = [
  { label: "Inicio", path: "/" },
  { label: "Servicios", path: "/servicios" },
  { label: "Equipo", path: "/equipo" },
  { label: "Blog", path: "/blog" },
  { label: "Contacto", path: "/contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled || !isHome
            ? "bg-white shadow-sm"
            : "bg-transparent"
        }`}
        style={{ height: "80px" }}
      >
        <div className="w-full h-full flex items-center justify-between px-6 md:px-10">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 flex items-center justify-center">
              <img src={LOGO_URL} alt="Logo Asesoría" className="w-10 h-10 object-contain" />
            </div>
            <span
              className={`font-bold text-lg tracking-tight hidden sm:block transition-colors duration-300 ${
                scrolled || !isHome ? "text-[#1A1A1A]" : "text-white"
              }`}
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Vidal Ferrer Asesores
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled || !isHome
                    ? location.pathname === item.path
                      ? "text-[#6B7F5C]"
                      : "text-[#4A4A4A] hover:text-[#6B7F5C]"
                    : location.pathname === item.path
                    ? "text-[#A0D080]"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="flex items-center gap-4">
            <Link
              to="/contacto"
              className="hidden md:flex items-center gap-2 bg-[#6B7F5C] text-white text-sm font-medium px-5 py-2.5 rounded-lg hover:bg-[#5A6E4B] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-check-line text-sm" />
              </div>
              Consulta Gratuita
            </Link>

            {/* Mobile hamburger */}
            <button
              className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
                scrolled || !isHome ? "text-[#1A1A1A]" : "text-white"
              }`}
              onClick={() => setMobileOpen((prev) => !prev)}
              aria-label="Abrir menú"
            >
              <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed top-[80px] left-0 right-0 bg-white z-40 transition-all duration-300 overflow-hidden shadow-lg ${
          mobileOpen ? "max-h-[400px] border-b border-gray-100" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4 gap-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-base py-3 px-4 rounded-lg font-medium transition-colors cursor-pointer ${
                location.pathname === item.path
                  ? "bg-[#F0F4ED] text-[#6B7F5C]"
                  : "text-[#2D2D2D] hover:bg-gray-50"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/contacto"
            className="mt-2 bg-[#6B7F5C] text-white text-sm font-medium px-5 py-3 rounded-lg hover:bg-[#5A6E4B] transition-colors text-center cursor-pointer"
          >
            Consulta Gratuita
          </Link>
        </nav>
      </div>
    </>
  );
}
